// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"215c4f1a","239":"d247834a","455":"562a8c3f","762":"bb718957"}[chunkId] + ".chunk.js";
};